import React, { useEffect, useState } from "react";

import { useHistory, useParams } from "react-router-dom";
import { format } from "date-fns";

import { FaDownload } from "react-icons/fa";

import { Flex, Button, Icon, Link, SimpleGrid, Box } from "@chakra-ui/react";

import LoadingSpinner from "../../../components/LoadingSpinner";
import Group from "../Visualizar/Group";
import Table from "./Table";
import NaoPossui from "./NaoPossui";

import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";
import GestaoSAService from "../../../../main/services/GestaoSAService";
import { API } from "../../../../main/config";

import {
  criancaFunc,
  Permission,
  servicos,
} from "../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import SemRegistros from "../../../components/SemRegistros";

const GestaoServicoAcolhimento = () => {
  const { id } = useParams();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [dataSA, setDataSA] = useState();

  const { roleKeycloack, user } = useAuthProvider();
  const hoje = new Date();

  const columnsEstatutoEntidade = [
    {
      Header: "Possui Estatuto da Entidade",
      accessor: "possuiEstatuto",
      Cell: (props) => {
        return <span>{props.value === "S" ? "SIM" : "NÃO"}</span>;
      },
    },
    {
      Header: "Última atualização",
      accessor: "ultimaAtualizacaoEstatuto",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
    {
      Header: "Estatuto da Entidade",
      accessor: "anexoEstatuto",
      Cell: (props) => {
        return (
          <span>
            {props.value && (
              <Link
                href={
                  props.value.pathAnexo.toString().includes(".png") ||
                  props.value.pathAnexo.toString().includes(".jpg") ||
                  props.value.pathAnexo.toString().includes(".jpeg") ||
                  props.value.pathAnexo.toString().includes(".pdf")
                    ? API + `/anexos/${props.value.id}/visualizar`
                    : API + `/anexos/${props.value.id}/download`
                }
                target="_blank"
              >
                <Icon
                  aria-label="Download"
                  color="#006064"
                  as={FaDownload}
                  boxSize="18px"
                  _hover={{ cursor: "pointer" }}
                />
              </Link>
            )}
          </span>
        );
      },
    },
  ];

  const columnsEntidadeGestora = [
    {
      Header: "Órgão/Entidade Gestora",
      accessor: "nomeEntidade",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Início da Gestão",
      accessor: "dataInicio",
      Cell: (props) => {
        return (
          <span>
            {props.value ? format(new Date(props.value), "dd/MM/yyyy") : ""}
          </span>
        );
      },
    },
    {
      Header: "Fim da Gestão",
      accessor: "dataFim",
      Cell: (props) => {
        return (
          <span>
            {props.value &&
            new Date(props.value).setHours(0, 0, 0, 0) >=
              hoje.setHours(0, 0, 0, 0)
              ? format(new Date(props.value), "dd/MM/yyyy")
              : ""}
          </span>
        );
      },
    },
  ];

  const columnsSupervisaoExterna = [
    {
      Header: "Supervisor Externo",
      accessor: "nomeEntidade",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Órgão/Entidade do Gestor Externo",
      accessor: "nomeSupervisor",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Início da Supervisão",
      accessor: "dataInicio",
      Cell: (props) => {
        return (
          <span>
            {props.value ? format(new Date(props.value), "dd/MM/yyyy") : ""}
          </span>
        );
      },
    },
    {
      Header: "Fim da Supervisão",
      accessor: "dataFim",
      Cell: (props) => {
        return (
          <span>
            {props.value &&
            new Date(props.value).setHours(0, 0, 0, 0) >=
              hoje.setHours(0, 0, 0, 0)
              ? format(new Date(props.value), "dd/MM/yyyy")
              : ""}
          </span>
        );
      },
    },
  ];

  const columnsSupervisaoOGMunicipal = [
    {
      Header: "Supervisor do Órgão Gestor Municipal",
      accessor: "nomeSupervisor",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Início da Supervisão",
      accessor: "dataInicio",
      Cell: (props) => {
        return (
          <span>
            {props.value ? format(new Date(props.value), "dd/MM/yyyy") : ""}
          </span>
        );
      },
    },
    {
      Header: "Fim da Supervisão",
      accessor: "dataFim",
      Cell: (props) => {
        return (
          <span>
            {props.value &&
            new Date(props.value).setHours(0, 0, 0, 0) >=
              hoje.setHours(0, 0, 0, 0)
              ? format(new Date(props.value), "dd/MM/yyyy")
              : ""}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    ServicoAcolhimentoService.getServicoAcolhimento(id)
      .then((res) => {
        setDataSA(res.data);
      })
      .catch((err) => {});

    GestaoSAService.getGestaoSA(id)
      .then((res) => {
        setLoading(false);
        setData(res.data);
      })
      .catch((erro) => {
        if (erro.response) {
          if (erro.response.data.status === 404) {
            history.push(`/servico-acolhimento/cadastrar-gestao/${id}`);
          }
        }
      });
  }, [history, id]);

  return roleKeycloack &&
    (roleKeycloack.includes(servicos.gestaoVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(dataSA?.idPessoaJuridica))) ? (
    !loading && data && dataSA ? (
      <>
        {dataSA.naturezaServico === "privada" && (
          <Group title="Estatuto da Entidade" mt="24px">
            {data.possuiEstatuto === "S" ? (
              <Table data={[data]} columns={columnsEstatutoEntidade} />
            ) : (
              <NaoPossui />
            )}
          </Group>
        )}

        <Group title="Órgão/Entidade Gestora" mt="24px">
          {data.possuiEntidadeGestora === "S" ? (
            data.listaEntidadeGestora?.length > 0 ? (
              <Table
                data={data.listaEntidadeGestora}
                columns={columnsEntidadeGestora}
                entidade={"gestora"}
              />
            ) : (
              <NaoPossui />
            )
          ) : (
            <NaoPossui />
          )}
        </Group>

        <Group title="Supervisão Externa" mt="24px">
          {data.possuiSupervisaoExterna === "S" ? (
            data.listaSupervisaoExterna?.length > 0 ? (
              <Table
                data={data.listaSupervisaoExterna}
                columns={columnsSupervisaoExterna}
                entidade={"supervisaoExterna"}
              />
            ) : (
              <NaoPossui />
            )
          ) : (
            <NaoPossui />
          )}
        </Group>

        <Group title="Supervisão do Órgão Gestor Municipal" mt="24px">
          {data.possuiSupervisaoOGMunicipal === "S" ? (
            data.listaSupervisaoOrgaoGestor?.length > 0 ? (
              <Table
                data={data.listaSupervisaoOrgaoGestor}
                columns={columnsSupervisaoOGMunicipal}
                entidade={"supervisaoGestor"}
              />
            ) : (
              <NaoPossui />
            )
          ) : (
            <NaoPossui />
          )}
        </Group>

        <SimpleGrid
          mt="30px"
          columns={{ base: 1, sm: 2, lg: 5 }}
          spacing="20px"
          dir="rtl"
        >
          <Permission
            roleKeycloack={roleKeycloack}
            func={servicos.gestaoEditar}
            id={dataSA?.idPessoaJuridica}
            user={user}
          >
            <Button
              color="#FFF"
              backgroundColor="#169499"
              fontWeight={700}
              fontSize="15px"
              lineHeight="21.6px"
              _hover={{ bg: "#169499" }}
              onClick={() => {
                history.push(`/servico-acolhimento/editar-gestao/${id}`);
              }}
            >
              Editar
            </Button>
          </Permission>
        </SimpleGrid>
      </>
    ) : (
      <Flex w="100%" mt="25%" justifyContent="center">
        <LoadingSpinner />
      </Flex>
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default GestaoServicoAcolhimento;
